/// <amd-module name="typeahead/core/IMinQueryLengthOverrider"/>

/// <reference path="../../typings/typeahead/plugins.d.ts"/>

export interface IMinQueryLengthOverrider {
    overrideMinQueryLength(context: IContext): JQueryPromise<number>;
}

export const isMinQueryLengthOverrider: IPluginIdentifier = (plugin: Object): boolean => {
    return _.isObject(plugin) && _.isFunction((plugin as IMinQueryLengthOverrider).overrideMinQueryLength);
};
